<template>
  <div id="app">
    <loading v-if="isLoading"></loading>
    <u-view></u-view>
  </div>
</template>

<script>
  import UView from 'common/components/u-view'
  import Loading from 'common/components/universal/loading/loading'
  import {mapGetters} from 'vuex'
  export default {
    name: 'app',
    components: {
      UView,
      Loading
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  }
</script>
<style>
  .cube-image-preview-footer{
    display: none;
  }
</style>
<style lang="stylus" rel="stylesheet/stylus">
  @import "common/stylus/index.styl"
  html,body
    user-select: auto
    .mobile
      user-select none
    @media (max-width: 768px)
      user-select none
  [placeholder]
    text-overflow ellipsis
</style>



// WEBPACK FOOTER //
// src/App.vue